@import 'src/styles/deviceBreakpoints';

.actionBtns {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .button {
    margin-left: 1em;
  }

  &.btnMargin {
    margin-top: 1em;
  }
}

.checkboxes {
  margin-top: 0.5rem;

  * {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
}
.modal {
  width: 70%;

  @include target(md) {
    width: 90%;
  }

  @include target(tablet) {
    width: 95%;
  }

  .overflowYVisible {
    overflow-y: visible;
  }

  .overflowYAuto {
    overflow-y: auto;
  }
}
